import { PageLoader } from '../ui/Spinner/Spinner'

export const SpinnerLoading = () => <PageLoader />

// Re-export PageLoader for components that import from here
export { PageLoader }
